import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import FlightItineraryNode from '../FlightItineraryNode'

export const FlightItinerary = Node.create({
  name: 'flightItinerary',

  group: 'block',

  atom: true, // Treated as a single unit

  draggable: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      flights: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('data-flights')
          return data ? JSON.parse(data) : []
        },
        renderHTML: attributes => {
          if (!attributes.flights || attributes.flights.length === 0) {
            return {}
          }
          return {
            'data-flights': JSON.stringify(attributes.flights),
          }
        },
      },
      passengerName: {
        default: null,
        parseHTML: element => element.getAttribute('data-passenger-name'),
        renderHTML: attributes => {
          if (!attributes.passengerName) {
            return {}
          }
          return {
            'data-passenger-name': attributes.passengerName,
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-flight-itinerary]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-flight-itinerary': '',
      }),
      0,
    ]
  },

  addCommands() {
    return {
      setFlightItinerary:
        options =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          })
        },
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(FlightItineraryNode)
  },
})
